var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"preparation"},[_vm._v("資料籌備中")])}
var staticRenderFns = []

export { render, staticRenderFns }